import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@playbookux/playbook-web-core';
import { LinkRed } from '../styles';
import { LoaderContainer } from './styles';

const ReprocessLink = ({ testSession, loading, onClick }) => {
  if (loading) {
    return (
      <LoaderContainer>
        <Loader data-loader="reprocess-loader" />
      </LoaderContainer>
    );
  }
  return (
    <>
      <LinkRed onClick={() => onClick(testSession.id)}>
        Reprocess
      </LinkRed>
      ,&nbsp;
    </>
  );
};

ReprocessLink.propTypes = {
  testSession: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ReprocessLink;
